import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

export const createHaulerModuleRoutesMap = (prefix: string) => ({
  // Own titles so the top-bar breadcrumb names the page instead of falling
  // back to the module title (design feedback 2026-07-24).
  contractors: pathJoin(prefix)('contractors').chainWithTitle({
    title: <T _str="Contractors" />,
    breadCrumbTitle: <T _str="Contractors" />,
  }),
  'contract-areas': pathJoin(prefix)('contract-areas').chainWithTitle({
    title: <T _str="Contract Areas" />,
    breadCrumbTitle: <T _str="Contract Areas" />,
  }),
  // DT1: full-page creation flow — registered before the list route so
  // it is matched ahead of it.
  'contract-areas-create': pathJoin(prefix)('contract-areas/create').chain,
  // DEV TASK 5: routed contract-area detail view.
  'contract-area-detail': (id = ':id') =>
    pathJoin(prefix)('contract-areas')(id).chain,
  // lane-C (PRO-121): the Coverage view (list-page toggle target) and its
  // full-page own-fleet marking flow — registered before the list route so
  // neither falls through to it.
  'contract-coverage': pathJoin(prefix)('contract-coverage').chain,
  'contract-coverage-own-fleet': pathJoin(prefix)('contract-coverage/own-fleet')
    .chain,
  // DEV TASK 4: retired zones home — route kept only as a redirect source.
  zones: pathJoin(prefix)('zones').chain,
  // DT2: contractor price configuration lives in Settings.
  'contractor-prices': pathJoin(prefix)('contractor-prices').chain,
})
